import React from 'react';
import Leftside from './Leftside'; // Adjust the import path as needed
import Header from './Header';     // Adjust the import path as needed
import { Outlet } from 'react-router-dom'; 
import Footer from './Footer';

const Layout = () => {    
    return (
        <div>
            <div id="wrapper">
                <Leftside />
                <Header />
                <Outlet />
                <Footer/>
            </div>
        </div>
    );
};

export default Layout;